import React from "react";
import {
  Form,
  Radio,
  Card,
  Select,
  Button,
  message,
  Drawer,
  Input,
  Collapse,
  Switch,
  Divider,
  Typography
} from "antd";
const { Text } = Typography;
import Prescription from "Pages/Others/Prescription";
import FormMedicine from "../../Components/FormMedicine";
import TableMedicineList from "Components/TableMedicineList";
import {
  addMedicines,
  addDurationTotal,
  addDurationMeasure,
  addFrequency,
  removeMedicines,
} from "../../store/slice/Medicine-slice";
import api from "utils/api";
import FormAddMedicine from "Components/FormAddMedicine";
import utils from "utils";
import debounce from "lodash.debounce";
import "./FormPrescription.scss";
import { ArrowRightOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import { setPublishClicked } from "store/slice/videoConsultation-slice";
import { LoadingOutlined } from "@ant-design/icons";
import { CONSTANTS } from "utils/constant";
import PublishPrescriptionPopup from "./MedicalTest/PublishPrescriptionPopup";

const { Panel } = Collapse;
const { TextArea } = Input;
class FormPrescription extends React.Component {
  diagnosis_form = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      prescriptions: [],
      is_herbal: false,
      edit_frequency: "",
      edit_duration: "",
      suggession: [],
      custom_diagnosis: [],
      custom_ailments: [],
      diagnosis_type: "predefined_diagnosis",
      ailments_type: "predefined_ailments",
      diagnosis_list: "",
      clinical_diagnosis: "",
      predefinedPrescription: [],
      predefinedPrescriptionSet: [],
      medicine_array: null,
      update_medicine: [],
      table_data: [],
      disable_button: false,
      on_edit: false,
      open_drawer: false,
      open_summary: false,
      column: "",
      form: "",
      prescription_type: "allopathy",
      allPrescriptionsList: [],
      prescriptionCount: 0,
      miniHeight: "0vh",
      selectedBrandId: 0,
      selectedDrugId: 0,
      predef_med_list: [],
      show_prescription: false,
      open_prescription: false,
      prescription_data: "",
      select_form: false,
      column: "",
      disableSearchMedicine: false,
      visible_publish: true,
      fetching: false,
      action: null,
      isSaving: false,
      prescription_saved:false,
      allow_reset:true,
      remove_medicine:[],
      comorbidities:[],
      prescriptionComments:"",
      prescription_comments_saved:false
    };
    this.search_medicine = React.createRef();
    this.addNewDrug = React.createRef(null);
  }

  componentDidMount() {
    if (this.props.table_data[0] != null) {
      this.setState({ update_medicine: this.props.table_data });
    }
    typeof this.props.formAction == "function" && this.props.formAction(false);
    let data = {
      app_id: this.props.appointment_id,
      type: "prescription",
    };
    api
      .get_consultation_details(data)
      .then((response) => {
        this.setState({ isloading: false });
        if (response.data.data?.results?.prescription.length > 0)
        {
          // this.setState({disable_type:true,})
          if(response.data.data.results.prescription.comments){
            this.setState({prescription_comments_saved:true})
          }
          this.setState({prescription_saved:true})
          typeof this.props?.visiblePublish == "function" &&
            this.props.visiblePublish();
        }
        this.setState({
          prescriptionComments:response.data.data?.results?.prescription[0].comments,
          response: response.data.data?.results?.prescription[0],
          visible_publish:
            response.data.data?.results?.prescription[0]
              ?.is_prescription_published,
        });
        if (this.state.response.is_allopathy || this.state.response.is_ayurveda)
          this.setState({ disable_type: true, allopathy_btn_text: "Update" });
        if (this?.state?.response?.clinical_diagnosis?.length > 0) {
          this.setState({
            diagnosis_type: "custom_diagnosis",
            custom_diagnosis: this.state.response.clinical_diagnosis,
          });
          this.diagnosis_form.current.setFieldsValue({
            clinical_diagnosis: "custom_diagnosis",
            diagnosis_updated: this.state.response.clinical_diagnosis,
          });
        }

        if (this?.state?.response?.comorbidities?.length > 0) {
          this.setState({
            ailments_type: "custom_ailments",
            custom_ailments: this.state?.response?.comorbidities,
          });
          this.diagnosis_form.current.setFieldsValue({
            comorbidities: "custom_ailments",
            ailments_updated: this.state?.response?.comorbidities,
          });
        }

        if (this.props.disablePrescription)
          if (
            this.state.response.is_yoga ||
            this.state.response.is_allopathy ||
            this.state.response.is_ayurveda ||
            this.state.response.is_diet
          )
            this.props?.disablePrescription(true);

        if (this.state.response?.is_allopathy) {
          this.setState({
            update_medicine: Object.values(
              this.state.response?.allopathy_medicine
            ),
            prescription_type: "allopathy",
          });
        }

        if (this.state.response?.is_ayurveda) {
          let ayurveda_medicine= this.state.response?.ayurveda_medicine ?[...this.state.response?.ayurveda_medicine]:[]
          this.setState({
              prescription_type: "ayurveda",
            prescriptions: ayurveda_medicine,
            update_medicine:  Object.values(
             ayurveda_medicine
            ),
           
          });
          this.diagnosis_form.current.setFieldsValue({ type: "ayurveda" });
        }

        if (this.state.prescriptions.length > 0) {
          this.setState({
            allopathy_btn_text: "Update",
            selected_type: this.state.response.is_allopathy
              ? "allopathy"
              : "ayurveda",
          });
        }
      })
      .catch(() => {});
      


    api
      .get_predefinded_diagnosis({ appointment_id: this.props.appointment_id })
      .then((res) => {
        this.setState({
          diagnosis_list: res.data?.data?.clinical_diagnosis?.length > 0 ? res.data?.data?.clinical_diagnosis?.join("\n") :  res.data?.data?.clinical_diagnosis || "",
          comorbidities: res.data?.data?.comorbidities?.length > 0 ? res.data?.data?.comorbidities.join("\n") :  res.data?.data?.comorbidities|| [],
        });
        this.diagnosis_form?.current?.setFieldsValue({
          ailments_from_form: this.state?.comorbidities,
          diagnosis_from_form: this.state?.diagnosis_list || "",
        });
      });
  }

  closePopup = () => {
    this.setState({open_publish_modal:false})
  }
  publishPrescription = (publish_data) =>{
    api.publish_prescription(publish_data)
            .then((res)=>{
              
        if(res.status==200){
          typeof this.props.prescriptionReportFunction == "function" && this.props.prescriptionReportFunction();
          typeof this.props?.visiblePublish == "function" &&
          this.props.visiblePublish(false);
          message.warning(res.data?.message, ErrorDuration);
          this.setState({updateData:true, alreadyPublished : true, buttonLoading: false,visible_publish:false,open_publish_modal:false});
        }
            })
  }
  onEditMedicine = (data, index) => {
    let frequencyValue = "";
    if (data?.frequency.includes("ml")) {
      frequencyValue = data.frequency.split("ml").join("");
    } else if (data?.frequency.includes("mg")) {
      frequencyValue = data.frequency.split("mg").join("");
    }else if (data?.frequency.includes("gms")) {
      frequencyValue = data.frequency.split("gms").join("");
    }
     else {
      frequencyValue = data?.frequency;
    }
    this.setState({
      edit_medicine_data: data,
      on_edit: true,
      disableSearchMedicine: true,
    });
    this.setState({
      edit_duration: data?.duration,
      edit_frequency: frequencyValue,
    });
    if (!this.state.on_edit) {
      this.handleChangeSelect(data, "edit");
      this.state.table_data.filter((item, i) => {
        if (item.drug_name != data.drug_name) {
          this.setState({ table_data: this.state.table_data.splice(i, 1) });
        }
      });
    }
  };
  // publishPrescription = () => {
  //   message.warning("Please wait few seconds, generating PDF...", 2);
    
  //   api
  //     .publish_prescription({
  //       app_id: this.props.appointment_id,
  //       prescription_mail: true,
  //     })
  //     .then((res) => {
  //       if (res.data?.status == 200) {
  //         // this.setState({is_prescription_report : true})
  //         typeof this.props.is_prescription_report_update == "function" &&
  //           this.props.is_prescription_report_update(true);
  //         typeof this.props.prescriptionReportFunction == "function" && this.props.prescriptionReportFunction();
  //         typeof this.props?.visiblePublish == "function" &&
  //           this.props.visiblePublish(false);
  //         message.success(res.data?.message, ErrorDuration);
  //       } else {
  //         message.error(res.data?.message, ErrorDuration);
  //       }
  //     });
  // };

  debouncedFunction = debounce((data) => {
    
    api
      .get_med_suggestion(
        data.trim(),
        this.state.prescription_type,
        this.state.is_herbal
      )
      .then((res) => {
        let search_suggessions = res?.data?.data?.results;
        this.setState({
          fetching: false,
          search_suggessions: search_suggessions,
          // selectedValue: data,
        });
      });
  }, 800);

  handleOnSearch = (data) => {
    this.setState({ searchValue: data.trim(), fetching: true });
    this.props.addFrequency("");
    if (data) {
      this.debouncedFunction(data);
    } else {
      this.setState({ fetching: false });
    }
  };
  viewFile(val) {
    api
      .preview_prescription({ app_id: this.props.appointment_id })
      .then((res) => {
        if (res.data.status == 200) {
          let file_path = res.data?.data || {};
          let final_filepath = file_path + "#toolbar=0&scrollbar=0";
          this.setState({
            open_prescription: true,
            prescription_data: final_filepath,
          });
        } else {
          message.error("Failed to save prescription", ErrorDuration);
        }
        this.setState({ isSaving: false });
      })
      .catch((error) => {
        this.setState({ isSaving: false });
        message.error("Failed to save prescription", ErrorDuration);
      });
  }

  renderDrawer = () => {
    return (
      <Drawer
        width={"70%"}
        title={
          <div className="pres-button">
            <div>{CONSTANTS.PREVIEW_PRESCRIPTION}</div>
            <div className="button-wrapper"   style={{dispay:"flex",flexDirection:"row-reverse",alignItems:"center"}}>
              <Button
                onClick={() => this.setState({ open_prescription: false })}
                className="cancel-btn"
                style={{ float: "right", margin: "10px" }}
              >
                {CONSTANTS.CLOSE}
              </Button>
              {!this.props.is_prescription_report && (
                <Button
                  onClick={() => this.setState({open_publish_modal:true})}  
                  className="confirm-btn"
                  style={{ float: "right", margin: "10px" }}
                >
                  {CONSTANTS.PUBLISH}
                </Button>
              )}
              {this.props.is_prescription_report &&  
              <Text type={"warning"}>{CONSTANTS.PRESCRIPTION_PUBLISH_IN_PROGRESS}
              </Text>}
    
            </div>
          </div>
        }
        closable={false}
        open={this.state.open_prescription}
      >
        <iframe
          height={window.screen.height - (window.screen.height / 100) * 35}
          width={window.screen.width - (window.screen.width / 100) * 38}
          src={this.state.prescription_data}
        ></iframe>
      </Drawer>
    );
  };

  onSave = (value,prescriptionNotes) => {
    let local_values = Object.values(value).map((i) => {
      let frequencyValue = "";
      if (i.frequency.includes("mg") || i.frequency.includes("ml")) {
        frequencyValue = i.frequency;
      } else {
        if (!i.frequency.includes("-")) {
          frequencyValue = i.frequency.split("").join("-");
        } else {
          frequencyValue = i.frequency;
        }
      }
      return {
        drug_id: i.drug_id,
        medicine_id: i.medicine_id,
        form_id: i.form_id,
        brand_id: i.brand_id,
        brand_name: i.brand || i.brand_name,
        route: i.route || "",
        adjuvant: i.adjuvant || "",
        drug_name: i.medicine || i.drug_name,
        form: utils.ConvertToPascalCase(i.form) || "",
        dosage: i.dosage,
        frequency: frequencyValue,
        duration: i.duration,
        instruction: i.instruction || "",
        is_allergic: false,
        type: i.type || "allopathy"
      };
    });

    var prescriptionFormData = {
      is_completed: this.props.prescriptionValue == "2" ? true : false,
      prescription_mail: false,
      type: this.state?.prescription_type || "",
      appointment_id: this.props.appointment_id,
      data: this.props.prescriptionValue == "2" ? local_values : [],
      comorbidities:
        this.state.ailments_type == "predefined_ailments"
          ? (this.state?.comorbidities?.length == 0 ? ["NIL"] : this.state?.comorbidities?.split("\n"))
          : this.diagnosis_form.current?.getFieldValue("ailments_updated")
              .length == 0
          ? ["NIL"]
          : typeof this.diagnosis_form.current?.getFieldValue(
              "ailments_updated"
            ) == "string"
          ? this.diagnosis_form.current?.getFieldValue("ailments_updated").split("\n")
          : this.diagnosis_form.current?.getFieldValue("ailments_updated"),
      clinical_diagnosis:
        this.state.diagnosis_type == "predefined_diagnosis"
          ? (this.state.diagnosis_list ? this.state.diagnosis_list : "NIL" )
          : (typeof this?.diagnosis_form.current?.getFieldValue(
              "diagnosis_updated"
            ) == "undefined" || !this?.diagnosis_form.current?.getFieldValue("diagnosis_updated"))
          ? "NIL"
          : this.diagnosis_form.current?.getFieldValue("diagnosis_updated"),
      is_prescription_required: true,
      comments: prescriptionNotes ?prescriptionNotes.trim() : "",
    };
    this.setState({ isSaving: true });
    if(prescriptionNotes){
      this.setState({prescription_comments_saved:true})
    }
    api.prescription_submit(prescriptionFormData).then((res) => {
      typeof this.props.formAction == "function" &&
        this.props.formAction(false);
      if (res.data.status == 200) {
        this.props.removeMedicines([]);
        typeof this.props?.visiblePublish == "function" &&
          this.props.visiblePublish();
        typeof this.props.handleFunction == "function" && this.props.handleFunction({ is_prescription: true });
        message.warning("Please wait few seconds, saving the prescription", ErrorDuration);
        this.props.setPublishClicked({ [this.props.appointment_id]: true });
        this.viewFile();
        this.setState({prescription_saved :true})
      } else message.error(res.data.message, ErrorDuration);
    });
  };

  onUpdateMedicine = (data, type) => {
    this.search_medicine.current.resetFields();
    this.props.addDurationMeasure("");
    this.props.addDurationTotal("");
    this.props.addFrequency("");
    let temp = [];
    data["duration"] =
      data?.["duration"]?.["total"] + " " + data?.["duration"]?.["measure"];
    data["drug_id"] = this.state.selectedDrugId;
    temp.push(data);
    this.props.addMedicines(temp[0]);
    
    typeof this.props.formAction == "function" && this.props.formAction(true);
    this.setState({
      disable_type:true,
      update_medicine: temp,
      on_edit: false,
      edit_duration: "",
      edit_frequency: "",
      available_forms: "",
      medicine_array: [],
      selectedValue: "",
      disableSearchMedicine: false,
    });
  };
  
  onClearMedicine = () => {
    this.search_medicine.current.resetFields(["search_medincine"]);
    this.setState({
      update_medicine: [this.state.edit_medicine_data],
      on_edit: false,
      medicine_array: [],
      disableSearchMedicine: false,
    });
  };

  onDeleteMedicine = (data, index) => {
    let temp = [];
  
    this.state.table_data.filter((item, i) => {
      if (i != index) {
        temp = this.state.table_data.splice(i, 1);
      }
    });
  
    this.setState({ table_data: temp });
    
  };
  openDrawer = (value) => {
    this.setState({ open_drawer: value });
  };
  handleDiagnosis = (e) => {
    this.setState({ diagnosis_type: e.target.value });
    if (this.state.custom_diagnosis.length == 0) {
      if (e.target.value == "custom_diagnosis") {
        this.diagnosis_form?.current?.setFieldsValue({
        diagnosis_updated: this.state.diagnosis_list,
        });
      }
    }
  };

  handleAilments = (e) => {
    this.setState({ ailments_type: e.target.value });
    if (this.state.custom_ailments.length == 0) {
      if (e.target.value == "custom_ailments") {
        this.diagnosis_form?.current?.setFieldsValue({
          ailments_updated: this.state.comorbidities,
        });
      }
    }
  };

  viewSummary() {
    this.setState({
      open_summary: true,
      miniHeight: "55vh",
    });
  }

  LoadPredefinedMedicine() {
    api.loadPreDefPrescribtionApi().then((res) => {
      this.setState({ predefined_prescrtiption: res.data.data?.results });
    });
  }

  SelectPredefinedPrescriptionType(value) {
    api.loadPrescriptionSet({ type: value }).then((res) => {
      this.setState({ predef_med_list: res.data.data.results });
    });
  }

  handleChangeSelect = (name, value) => {
    // if(value !="add_form"){
    //   this.setState({select_form:false})
    // }]
   
    if(name){
    this.setState({
      selectedValue: name?.medicine_id,
      selectedBrandId: name?.brand_id,
      selectedDrugId: name?.drug_id,
      column: value,
    });
    if (value === "add" || value === "edit") {
      this.setState({ action: value });
    }
    let data = {
      medicine_id: name?.medicine_id || name,
      form_id: value == "edit" ? "" : name?.form_id || "",
      brand_id: name?.brand_id || this.state.selectedBrandId,
      drug_id: name?.drug_id || this.state.selectedDrugId,
      dosage: value == "edit" ? "" : name?.dosage || "",
      route: 0,
      adjuvant: 0,
      frequency: "",
    };

    api.post_med_id(data).then((res) => {
      let available_forms = res.data?.data?.form_dosage;
      let results = res.data?.data;
      if (value == "edit") {
        (results["form"] = this.state.edit_medicine_data?.form),
          (results["dosage"] = this.state.edit_medicine_data?.dosage),
          (results["frequency"] = this?.state?.edit_frequency || "");
        results["duration"] = this?.state?.edit_duration || "";
        results["instruction"] = this.state.edit_medicine_data?.instruction;
        // if (this.state.prescription_type == "ayurveda") {
        results["frequency_measure"] =
          this.state.edit_medicine_data?.frequency_measure;
        // }
        this.setState({ medicine_array: results, column: value });
      } else {
        this.setState({ medicine_array: res.data.data, column: value });
      }
      if (value == "edit" || value == "add") {
        this.setState({ available_forms: available_forms });
      }
    });
  }else{
    this.setState({medicine_array:[],search_suggessions:[]})
  }
  };

  onSelectForm = (val, action) => {
    this.setState({ select_form: true });
    let data = {
      medicine_id: this.state.selectedValue,
      form_id: val.form_id,
      dosage: val.strength_dosage,
      brand_id: this.state.selectedBrandId,
      form_name: val.form_name,
      drug_id: this.state.selectedDrugId,
    };
    this.handleChangeSelect(data, "add_form");
  };
  onRemoveMedicine = (e,col) => {
    
    this.setState({disable_type:false})   
    
   
  };
  onRemoveFormMed=(e,col)=>{
    
    if(col=="remove_med"){
     
      this.setState({remove_medicine:e})
    }
  }
  onClearSearch = () => {
  
    this.search_medicine.current.resetFields(["search_medincine"]);
    this.setState({
      medicine_array: [],
      selectedValue: "",
      search_suggessions: [],
      selectedValue: "",
    });
  };
  onPopConfirmClose = ()=>{
    this.setState({ isSaving: false });
  }
  render() {
    let { open_prescription } = this.state;
    return (
      <>
        <div className="prescription-wrapper">
          <div className="comorbiditites-diagnosis-block" ref={this.addNewDrug}>
            <Form
              name={"form"}
              ref={this.diagnosis_form}
              style={{}}
              colon={false}
              onFinish={(value) => this.handleSubmit(value)}
            >
              <div className="retrive-block">
                <div>
                  <Collapse
                    style={{
                      background: "white",
                      border: "1px solid lightgray",
                    }}
                  >
                    <Panel header={CONSTANTS.DIAGNOSIS} key={"1"}>
                      <Form.Item
                        name={["clinical_diagnosis"]}
                        labelCol={{ span: 2 }}
                        wrapperCol={{ xs: 24}}
                        className={"diagnosis_radio comorbidities"}
                      >
                        <Radio.Group
                          defaultValue={"predefined_diagnosis"}
                          onChange={(e) => {
                            this.handleDiagnosis(e);
                          }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <Radio value={"predefined_diagnosis"}>
                              {CONSTANTS.FROM_DIAGNOSIS_FORM}
                            </Radio>
                            <Form.Item name={["diagnosis_from_form"]}>
                              <TextArea
                                rows={4}
                                disabled
                                // style={{ minWidth: "400px" }}
                                className="text-field"
                                placeholder={CONSTANTS.FROM_DIAGNOSIS_FORM}
                              />
                            </Form.Item>
                          </div>
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <Radio value={"custom_diagnosis"}>
                              {CONSTANTS.REVISED_DIAGNOSIS}
                            </Radio>
                            <Form.Item name={["diagnosis_updated"]}>
                              <TextArea
                                disabled={
                                  this.state.diagnosis_type ==
                                  "predefined_diagnosis"
                                    ? true
                                    : false
                                }
                                rows={4}
                                // style={{ minWidth: "400px" }}
                                placeholder={CONSTANTS.ADD_OR_EDIT}
                              />
                            </Form.Item>
                          </div>
                        </Radio.Group>
                      </Form.Item>
                    </Panel>
                  </Collapse>
                </div>
                {/* <div>
                  <Collapse
                    style={{
                      background: "white",
                      border: "1px solid lightgray",
                    }}
                  >
                    <Panel header={CONSTANTS.COMORBITIES} key={"2"}>
                      <Form.Item
                        name={["comorbidities"]}
                        labelCol={{ span: 2 }}
                        wrapperCol={{ xs:24 }}
                        className={"diagnosis_radio comorbidities"}
                      >
                        <Radio.Group
                          defaultValue={"predefined_ailments"}
                          onChange={(e) => {
                            this.handleAilments(e);
                          }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <Radio value={"predefined_ailments"}>
                              {CONSTANTS.COMORBIDITIES_HI_FORM}
                            </Radio>

                            <Form.Item name={["ailments_from_form"]}>
                              <TextArea
                                rows={4}
                                disabled
                                // style={{ minWidth: "400px" }}
                                placeholder={CONSTANTS.COMORBIDITIES_FROM_FORM}
                              />
                            </Form.Item>
                          </div>

                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <Radio value={"custom_ailments"}>
                              {CONSTANTS.REVISED_COMORBIDITIES}
                            </Radio>

                            <Form.Item name={["ailments_updated"]}>
                              <TextArea
                                rows={4}
                                disabled={
                                  this.state.ailments_type ==
                                  "predefined_ailments"
                                    ? true
                                    : false
                                }
                                // style={{ minWidth: "400px" }}
                                placeholder={CONSTANTS.ADD_OR_EDIT_COMORBIDITIES}
                              />
                            </Form.Item>
                          </div>
                        </Radio.Group>
                      </Form.Item>
                    </Panel>
                  </Collapse>
                </div> */}
              </div>
            </Form>
          </div>
          <div className="mid-block">
            <div className="mid-block-inner-content"
              style={{
                // display: "flex",
                // justifyContent: "space-between",
                // width: "100%",
                // alignItems: "center",
                // border: "1px solid lightgray",
                // margin: "15px 0",
                // padding: "0 10px",
                // borderTopRightRadius: "20px",
                // borderTopLeftRadius: "20px",
              }}
            >
              <div className="mid-block-inner-1st-content"
                // style={{
                //   width: "50%",
                //   display: "flex",
                //   justifyContent: "space-between",
                //   alignItems: "center",
                // }}
              >
                <Form.Item style={{ display: "flex", flexDirection: "row" }}>
                  <Radio.Group
                    disabled={this.state.disable_type|| this.state.prescription_comments_saved}
                    value={this.state.prescription_type}
                    onChange={(e) => {
                      this.setState({
                        prescription_type: e.target.value,
                        medicine_array: [],
                        available_forms: [],
                        search_suggessions: []
                      });
                      this?.search_medicine?.current?.resetFields();
                    }}
                  >
                    <Radio value={"allopathy"}>{CONSTANTS.ALLOPATHY}</Radio>
                    <Radio value={"ayurveda"}>{CONSTANTS.AYURVEDA}</Radio>
                  </Radio.Group>
                </Form.Item>

                <Form.Item
                  style={{ paddingRight: "8px" }}
                  colon={false}
                  name={"is_herbal"}
                  label={CONSTANTS.INCLUDE_HERBAL}
                >
                  <Switch
                    style={{ marginTop: "4px" }}
                    onClick={(e) => this.setState({ is_herbal: e })}
                  >
                    {CONSTANTS.HERBAL}
                  </Switch>
                </Form.Item>
              </div>
              <div className="summary-btn" onClick={() => this.viewSummary()}>
                {CONSTANTS.VIEW_SUMMARY}
                <ArrowRightOutlined style={{ paddingLeft: "4px" }} />
              </div>
            </div>

            <div
              style={{
                borderRadius: "20px",
                position: "relative",
                display: "flex",
              }}
            >
              <div className="drug-details-block" style={{ width: "100%" }}>
                <div className="search-block">
                  <Form ref={this.search_medicine} style={{ width: "100%" }}>
                    <Form.Item name={"search_medincine"}>
                      <Select
                        allowClear
                        // onClear={()=>{this.handleChangeSelect("")}}
                        placement="bottomLeft"
                        className="suggest-select"
                        disabled={
                          this.props.prescriptionValue != "2" ||
                          this.state.disableSearchMedicine ||
                          this.props?.is_prescription_report
                        }
                        showSearch
                        notFoundContent={
                          this.state.fetching ? (
                            <LoadingOutlined
                              style={{
                                fontSize: 18,
                                color: "#134E48",
                              }}
                              spin
                            />
                          ) : null
                        }
                        aria-autocomplete="true"
                        optionLabelProp="label"
                        autoClearSearchValue={true}
                        filterOption={false}
                        onChange={(e) => {   
                          this.handleChangeSelect(
                            this?.state?.search_suggessions[e],
                            "add"
                          );
                        }}
                        style={{ width: "100%", paddingLeft: "0px !important" }}
                        onSearch={this.handleOnSearch.bind(this)}
                        getPopupContainer={(trigger) => trigger.parentNode}
                        popupClassName="bottom-positioned-dropdown"
                        placeholder={"Search"}
                        optionFilterProp="children"
                      >
                        {Object.values(
                          this?.state?.search_suggessions || []
                        ).map((m, i) => (
                          <>
                            <Select.Option
                              className="suggest-option"
                              label={m.medicine}
                              key={i}
                            >
                              {m?.brand
                                ? m.medicine + "[" + m.brand + "]"
                                : m.medicine}
                            </Select.Option>
                          </>
                        ))}
                      </Select>
                    </Form.Item>
                  </Form>
                  {!this.props?.is_prescription_report && (
                    <div className="button-wrapper" style={{ display: "flex" }}>
                      <Button
                        className="confirm-btn add-drug-btn"
                        onClick={() => {
                          this.setState({ open_drawer: true });
                          this.addNewDrug?.current?.scrollIntoView({ behavior: "smooth",
                          scrollMode: "if-needed",
                          block: 'center', });
                        }}
                      >
                        {CONSTANTS.ADD_NEW_DRUG}
                      </Button>
                    </div>
                  )}
                </div>

                <div
                  style={{ minHeight: this.state.miniHeight }}
                  className="med-block"
                >
                  <FormMedicine
                    data={"med_form"}
                    select_form={this.state.select_form}
                    medicine_array={this.state.medicine_array}
                    onUpdateMedicine={this.onUpdateMedicine}
                    onClearSearch={this.onClearSearch}
                    onClearMedicine={this.onClearMedicine}
                    on_edit={this.state.on_edit}
                    action={this.state.action}
                    open_summary={this.state.open_summary}
                    onSelectForm={this.onSelectForm}
                    prescription_type={this.state.prescription_type}
                    available_forms={this.state.available_forms}
                    selectedValue={this.state.selectedValue}
                    edit_duration={this.state.edit_duration}
                    edit_frequency={this.state.edit_frequency}
                    column={this.state.column}
                    update_medicine={this.state.update_medicine}
                    remove_medicine={this.state.remove_medicine}
                  />
                </div>
              </div>

              <div className="summary-drawer">
                <Drawer
                  title={
                    <div className="summary-close">
                      <div>{CONSTANTS.SUMMARY}</div>
                      <div>
                        <Button
                          className="close-button"
                          onClick={() =>
                            this.setState({
                              open_summary: false,
                              miniHeight: "0vh",
                            })
                          }
                        >
                          {CONSTANTS.CLOSE}
                        </Button>
                      </div>
                    </div>
                  }
                  style={{ padding: "0px" }}
                  getContainer={false}
                  width={"70%"}
                  mask={false}
                  destroyOnClose={true}
                  closable={false}
                  open={this.state.open_summary}
                >
                  <>
                    <Prescription
                      from="consultation"
                      data={{ patient_id: this.props?.patient_id || "" }}
                    />
                  </>
                </Drawer>
              </div>
              <Drawer
                open={this.state.predefined_med_drawer}
                onClose={() =>
                  this.setState({
                    predefined_med_drawer: false,
                    miniHeight: "0vh",
                  })
                }
                mask={false}
                destroyOnClose={true}
              >
                <div>
                  <p>{CONSTANTS.PREDEFINED_MEDICINE}</p>
                  <Select
                    placement="bottomLeft"
                    className="suggest-select"
                    showSearch
                    notFoundContent={true}
                    aria-autocomplete="true"
                    optionLabelProp="label"
                    autoClearSearchValue={true}
                    style={{ width: "100%", paddingLeft: "0px !important" }}
                    getPopupContainer={(trigger) => trigger.parentNode}
                    placeholder={CONSTANTS.SEARCH_BY_DIAGNOSIS}
                    optionFilterProp="children"
                    onChange={(value) =>
                      this.SelectPredefinedPrescriptionType(value)
                    }
                  >
                    {Object.values(
                      this?.state?.predefined_prescrtiption || []
                    ).map((m, i) => (
                      <>
                        <Select.Option
                          className="suggest-option"
                          value={m}
                          label={m}
                          key={i}
                        >
                          {m}
                        </Select.Option>
                      </>
                    ))}
                  </Select>

                  {this.state?.predef_med_list.map((i, k) => {
                    return (
                      <Card>
                        <div key={k}>
                          <p>
                            {i?.brand_name}|{i?.drug_name}|{i?.frequency}
                          </p>
                          <p>
                            {i.form}|{i.dosage}|{i.duration}
                          </p>
                          <p>{i?.instruction}</p>
                          <p>{"Consume with: " + i?.adjuvant}</p>
                          <p>{"Route:" + i?.route}</p>

                          <Button
                            onClick={() => {
                              this.onUpdateMedicine(i, k);
                            }}
                          >
                            {CONSTANTS.ADD}
                          </Button>
                          <Button onClick={() => {}}>{CONSTANTS.EDIT}</Button>
                        </div>
                      </Card>
                    );
                  })}
                </div>
              </Drawer>
              <Drawer
                open={this.state.show_prescription}
                onClose={() =>
                  this.setState({ show_prescription: false, miniHeight: "0vh" })
                }
                mask={false}
                destroyOnClose={true}
              ></Drawer>
            </div>
          </div>
          {open_prescription ? this.renderDrawer() : ""}
        </div>
        <div className="drug-table">
          <TableMedicineList
          onRemoveFormMed={this.onRemoveFormMed}
            onEditMedicine={this.onEditMedicine}
            table_data={this.state.table_data}
            prescriptions={this.state.prescriptions}
            prescription_saved={this.state.prescription_saved}
            submited_data={this.state.prescriptions}
            prescription_type={this.state.prescription_type}
            prescriptionValue={this.props.prescriptionValue}
            isSaving={this.state.isSaving}
            onPopConfirmClose={this.onPopConfirmClose.bind(this)}
            prescription_comments_saved={this.state.prescription_comments_saved}
            onSave={this.onSave}
            comments={this.state.prescriptionComments}
            onRemoveMedicine={this.onRemoveMedicine}
            on_edit={this.state.on_edit}
            update_medicine={this.state.update_medicine}
            visible_publish={this.state.visible_publish}
            is_prescription_report={this.props?.is_prescription_report}
          />
        </div>

        <FormAddMedicine
          openDrawer={this.openDrawer}
          open_drawer={this.state.open_drawer}
        
        />
        {this.state?.open_publish_modal?
         <PublishPrescriptionPopup
         app_id={this.props.appointment_id}
         open_publish_modal={this.state.open_publish_modal}
         closePopup={this.closePopup}
         publishPrescription={this.publishPrescription}
         />:null}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  
  return {
    table_data: state.MedicineSlice.medicine_table,
  };
};
const mapDispatchToProps = {
  addMedicines,
  addDurationTotal,
  addDurationMeasure,
  addFrequency,
  removeMedicines,
  setPublishClicked,
};
export default connect(mapStateToProps, mapDispatchToProps)(FormPrescription);
